import React, {useCallback, useState} from "react";
import PaymentForm from "./PaymentForm";
import {validateCreditCard} from "../../../api/creditCard/creditCard.js";
import "./payment.css";

export const Payment = ({parseResponse, creditCardExist}) => {
    const [loading, setLoading] = useState(false);
    const [isValidCreditCard, setIsValidCreditCard] = useState(true);

    const onSaveCreditCard = useCallback(
        async values => {
            setLoading(true);

            const {creditCardNumber, expiry, cvv} = values;
            const [expiryMonth, expiryYear] = expiry.split("/");

            const creditCardValidationResponse = await validateCreditCard(
                creditCardNumber,
                parseInt(expiryMonth),
                parseInt(expiryYear),
                cvv
            );

            if (creditCardValidationResponse?.error) {
                setIsValidCreditCard(false);
            }

            parseResponse(creditCardValidationResponse);

            setLoading(false);
        },
        [parseResponse]
    );

    return (
        <>
            <PaymentForm handleSubmit={onSaveCreditCard} creditCardExist={creditCardExist} loading={loading} />
            {!isValidCreditCard && (
                <div className="invalid-credit-card">שגיאה בפרטי כרטיס אשראי. נא לבדוק את כל השדות</div>
            )}
        </>
    );
};
